export default __webpack_public_path__ + "static/media/Gauntlets of Unrest.50a8932c.jpg";